import { render, staticRenderFns } from "./NivellCrud.vue?vue&type=template&id=1f2a0575&scoped=true&"
import script from "./NivellCrud.vue?vue&type=script&lang=js&"
export * from "./NivellCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a0575",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
